<template>
  <div class="register-document split-view fill-height">

    <v-row class="split-view__row fill-height" no-gutters>
      <left-side-image/>
      <v-col cols="12" md="7" class="split-view__panel">
        <div class="split-view__scroll">
        <nav-bar-page/>

        <v-row justify="center" class="mt-0">
          <v-col cols="12" class="mt-0 py-0">
            <div class="my-0 pt-0 primary--text">
              <h1 class="text-center today-regular text-title">REGISTRAR DOCUMENTO</h1>
              <h3 class="primary--text text-center mb-0 today-light">Escanea la parte delantera y posterior de tu cédula</h3>
            </div>
          </v-col>
          <v-col cols="12" md="12" lg="12">

            <v-img src="@/assets/img/tarjeta-de-identificacion.png" height="180" class="mt-4" contain alt="Registro de documento"></v-img>

            <v-row justify="center" class="mt-3">
              <v-col cols="10" md="8" lg="8">
                <ul class="primary--text">
                  <li class="mt-3 text-justify py-1"><h2 class="today-light line-height-1 text-list">Ubica tu cédula en una superficie plana y con buena iluminación.</h2></li>
                  <li class="mt-3 text-justify py-1"><h2 class="today-light line-height-1 text-list">Asegúrate enfocar bien la imagen en el recuadro.</h2></li>
                  <li class="mt-3 text-justify py-1"><h2 class="today-light line-height-1 text-list">Espera unos segundos mientras la imagen carga.</h2></li>
                </ul>
              </v-col>
            </v-row>

            <v-layout justify-center pt-4>
              <v-card-actions>
                <v-btn
                    style="min-width: 240px"
                    @click="goUploadDocument"
                    color="primary"
                    rounded
                    class="px-12 text-capitalize vardi-button"
                    elevation="0">
                  CONTINUAR
                </v-btn>
              </v-card-actions>
            </v-layout>

          </v-col>
        </v-row>
        </div>
      </v-col>
    </v-row>

  </div>

</template>

<script>
import LeftSideImage from "@/components/Layouts/LeftSideImage";
import NavBarPage from "@/components/Layouts/NavBarPage";

export default {
  name: 'RegisterDocument',
  components: {LeftSideImage, NavBarPage},
  data() {
    return {
      settings: []
    }
  },
  created() {
    this.settings = JSON.parse(localStorage.getItem('settings'));
    console.log('RegisterDocument', this.settings);
  },
  methods: {
    goUploadDocument() {
      this.$router.push('/subir-documento');
    }
  }
}
</script>
<style scoped>

.v-toolbar__content {
  justify-content: left !important;
}

.v-list-item--dense {
  min-height: 30px;
}

li::marker {
  color: #FFD100;
}

</style>